/**
 * AIT error classes.
 */

/** Base error for AIT operations */
export class AITError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "AITError";
  }
}

/** Invalid AIT file format */
export class AITFormatError extends AITError {
  constructor(message: string) {
    super(message);
    this.name = "AITFormatError";
  }
}

/** Unsupported AIT format version */
export class AITVersionError extends AITError {
  constructor(message: string) {
    super(message);
    this.name = "AITVersionError";
  }
}

